import { AppBar, Box, CircularProgress } from "@mui/material";
import { KeyDriveh4Header } from "../KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { KeyDriveCaption } from "../KeydriveComponents/Fonts/Captions/KeyDriveCaption";
import { KeyDrivePrimaryButton } from "../KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { useEffect, useState } from "react";
import { GetOneOrganization } from "../../services/OrganizationServices";
import { useTranslation } from "react-i18next";

interface IFreeSoftwareAlert {
    isCollapsed: boolean;
    nameOrg: string;
}

export default function FreeSoftwareAlert({
    isCollapsed,
    nameOrg
}: IFreeSoftwareAlert) {

    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const profile = useProfile();
    const { t } = useTranslation();
    const [loadingAdmButton, setLoadingAdmButton] = useState<boolean>(false);

    useEffect(() => {
        if (nameOrg) {
            setLoadingAdmButton(true);
            GetOneOrganization(nameOrg)
            .then(res => {
                setIsAdmin(res?.adminUsers?.includes(profile?.id!)!);
            })
            .catch(() => {
                setIsAdmin(false);
            })
            .finally(() => {
                setLoadingAdmButton(false);
            })
        }
    }, [nameOrg]);

    if (nameOrg == undefined) {
        return <></>
    }

    return (
        <AppBar
            sx={{
                width: `${isCollapsed ? "calc(100% - 66px)" : "calc(100% - 220px)"}`,
                height: "50px",
                marginTop: "66px",
                backgroundColor: "#22638D",
                padding: "4px"
            }}
        >
            <Box    
                width="100%"
                height="100%"
                display="flex"
                justifyContent="space-between"
            >
                <Box>
                    <KeyDriveh4Header 
                        text={t('FreeSoftwareAlert.title')}
                        color="#E8EFF3"
                        needBold={false}
                        needEllipses={false}
                    />
                    <KeyDriveCaption 
                        text={isAdmin
                            ? t('FreeSoftwareAlert.admin')
                            : t('FreeSoftwareAlert.user')
                        }
                        color="#E8EFF3"
                        needBold={false}
                        needEllipses={false}
                    />
                </Box>
                { loadingAdmButton ? (
                    <>
                        <CircularProgress color="inherit" size={24} variant="indeterminate" />
                    </>
                ) : (
                    <>
                        { (isAdmin || profile?.adminSystem) && nameOrg && (
                            <KeyDrivePrimaryButton
                                endIcon={<ArrowForwardIos />}
                                width="250px"
                                TextComponent={KeyDriveCaption}
                                TextComponentProps={{
                                    color: "#E8EFF3",
                                    needBold: false,
                                    needEllipses: false,
                                    text: t("FreeTier.AccessPlans")
                                }}
                                needFullWidth={false}
                                backgroundColor="#F58601"
                                disabled={nameOrg == undefined}
                                onClick={()=> {
                                    navigate(`${nameOrg}/adminConsole/plans`);
                                }}
                            />
                        ) }
                    </>
                ) }
            </Box>
        </AppBar>
    )
}